import { render, staticRenderFns } from "./MasterSecurity.vue?vue&type=template&id=a9bf880a&scoped=true"
import script from "./MasterSecurity.vue?vue&type=script&lang=js"
export * from "./MasterSecurity.vue?vue&type=script&lang=js"
import style0 from "./MasterSecurity.vue?vue&type=style&index=0&id=a9bf880a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bf880a",
  null
  
)

export default component.exports